export enum SectionTypeEnum {
  SLOT = 'slot',
  SUMMARY = 'summary',
  SIDEBAR = 'sidebar',
}
